export const COLOR_TITLE_GROUPS = [
    {
      color: "#34D399",
      bgColor: "#C4FFE1",
      titles: ["Patience", "Persistence", "Thoughtfulness"]
    },
    {
      color: "#B6A1FB",
      bgColor: "#D6C9FF",
      titles: ["Enthusiasm", "Friendliness", "Self Confidence"]
    },
    {
      color: "#F17D8B",
      bgColor: "#FFC5CD",
      titles: ["Efficiency", "Independence", "Self Motivation"]
    },
    {
      color: "#FBC43B",
      bgColor: "#FFEFC5",
      titles: ["Accuracy", "Cooperativeness", "Sensitivity"]
    }
  ];